import { AppVariants } from "common/types/appVariant";

import isGoStudentLearningApp from "features/goStudentLearning/utils/isGoStudentLearningApp";
import { isPlurallApp } from "features/plurall";
import { isPrimaryApp } from "features/primary/selectors";

export const appNames = {
  seneca: "Seneca",
  senecaPrimary: "Seneca",
  plurall: "Adapta",
  goStudentLearning: "GoStudent Learning"
};

export function getAppVersion() {
  return import.meta.env.VITE_APP_VERSION;
}

export function getAppName() {
  const appVariant = getAppVariant();
  return appNames[appVariant];
}

export function getAppVariant() {
  if (isPlurallApp()) return AppVariants.plurall;
  if (isGoStudentLearningApp()) return AppVariants.goStudentLearning;
  if (isPrimaryApp()) return AppVariants.senecaPrimary;

  return AppVariants.seneca;
}
